'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _templateObject = _taggedTemplateLiteral(['\n  fill: ', ';\n'], ['\n  fill: ', ';\n']),
  _templateObject2 = _taggedTemplateLiteral(['\n  width: ', ';\n  height: ', ';\n'], ['\n  width: ', ';\n  height: ', ';\n']);
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _styledComponents = require('styled-components');
var _styledComponents2 = _interopRequireDefault(_styledComponents);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
var StyledPath = _styledComponents2.default.path(_templateObject, function (props) {
  return props.theme[props.fill || 'color_white'];
});
var StyledSVG = _styledComponents2.default.svg(_templateObject2, function (props) {
  return props.width;
}, function (props) {
  return props.height;
});
var Plus = function Plus(_ref) {
  var fill = _ref.fill,
    width = _ref.width,
    height = _ref.height;
  return _react2.default.createElement(StyledSVG, {
    width: width,
    height: height,
    viewBox: '0 0 13.28 13.28'
  }, _react2.default.createElement('g', {
    id: '_8',
    'data-name': ' 8'
  }, _react2.default.createElement(StyledPath, {
    fill: fill,
    'class': 'cls-1',
    d: 'M8.4,1.92A6.64,6.64,0,1,0,15,8.56,6.64,6.64,0,0,0,8.4,1.92Zm0,12.45a5.81,5.81,0,1,1\r ,5.81-5.81A5.81,5.81,0,0,1,8.4,14.37Zm2.49-6.22H8.81V6.07a.42.42,0,0,0-.83,0V8.15H5.91a.42.42,0,0,0,0,\r .83H8v2.08a.42.42,0,0,0,.83,0V9h2.08a.42.42,0,0,0,0-.83Z',
    transform: 'translate(-1.76 -1.92)'
  })));
};
exports.default = Plus;